if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 990px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}


// let flkty = null;

// const triggers = document.querySelectorAll("[data-expand-gallery-open]");

// if (triggers.length > 0) {
//   triggers.forEach((trigger) => {
//     trigger.addEventListener("click", function () {

//       const mediaId = this.getAttribute("data-expand-media-id");

//       // Open gallery first
//       const gallery = document.querySelector("[media-gallery-expand]");
//       gallery.classList.add("active");

//       const cells = document.querySelectorAll(".gallery-cell");

//       let targetIndex = 0;
//       cells.forEach((cell, index) => {
//         if (cell.getAttribute("data-media-id") === mediaId) {
//           targetIndex = index;
//         }
//       });

//       // Initialize Flickity AFTER opening (important)
//       if (!flkty) {
//         flkty = new Flickity('.flickity-slider-wrapper', {
//           cellAlign: 'center',
//           contain: true,
//           wrapAround: true,
//           pageDots: true
//         });
//       }

//       // Wait a tick to ensure layout is ready
//       setTimeout(() => {
//         flkty.resize();
//         flkty.select(targetIndex);
//       }, 50);

//     });
//   });
// }

let flkty = null;

const triggers = document.querySelectorAll("[data-expand-gallery-open]");
const gallery = document.querySelector("[media-gallery-expand]");
const slider = document.querySelector(".flickity-slider-wrapper");
const closeBtn = document.querySelector(".gallery-close-btn");

const prevBtn = document.querySelector(".arrow.prev");
const nextBtn = document.querySelector(".arrow.next");

if (triggers.length > 0) {
  triggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {

      const mediaId = this.getAttribute("data-expand-media-id");

      gallery.classList.add("active");

      const cells = document.querySelectorAll(".gallery-cell");

      let targetIndex = 0;
      cells.forEach((cell, index) => {
        if (cell.getAttribute("data-media-id") === mediaId) {
          targetIndex = index;
        }
      });

      if (!flkty) {
        flkty = new Flickity('.flickity-slider-wrapper', {
          cellAlign: 'center',
          contain: true,
          wrapAround: true,
          pageDots: true,
          prevNextButtons: false // disable default arrows
        });
      }

      setTimeout(() => {
        flkty.resize();
        flkty.select(targetIndex);
      }, 50);

    });
  });
}

/* ✅ CLOSE BUTTON */
closeBtn.addEventListener("click", () => {
  gallery.classList.remove("active");
});

/* ✅ CLICK OUTSIDE TO CLOSE */
gallery.addEventListener("click", (e) => {
  // If clicked inside slider OR on controls → do nothing
  console.log("e.target.closest()---", e.target)
  if (e.target.closest(".flickity-slider-wrapper") || e.target.closest(".gallery-nav") || e.target.closest(".gallery-close") || e.target.closest("button")) {
    return;
  }

  // Otherwise close
  gallery.classList.remove("active");
});

/* ✅ CUSTOM ARROWS */
prevBtn.addEventListener("click", () => {
  if (flkty) flkty.previous();
});

nextBtn.addEventListener("click", () => {
  if (flkty) flkty.next();
});